import styled from 'styled-components';

export const ImageContainer = styled.div`
  width: ${(props) => props.imageWidth || '100%'};
  height: ${(props) => props.imageHeight || '100%'};
  max-width: ${(props) => props.maxWidth || 'content-max'};
  min-width: ${(props) => props.minWidth || 'content-max'};
  display: ${(props) => props.display || 'block'};
  padding: ${(props) => props.padding || '0'};
`;
